import { atom } from 'recoil';

export default atom({
  key: 'baseKey',
  default: 0,
});
